"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var getNotifications = function (subdomain) {
    return (0, service_1.getService)()
        .get("/customers/subdomain/".concat(subdomain, "/outage_notifications"))
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
exports.default = getNotifications;
